export default {
  filters: {
    formatNumber(number) {
      if (!Number.isInteger(number) && !!(number % 1) === false) {
        return number;
      }
      const options = { maximumFractionDigits: 2, minimumFractionDigits: 2 };
      return parseFloat(number).toLocaleString(undefined, options);
    },
    roundNumber(number, decimalPlaces = 2) {
      return Number(
        `${Math.round(
          parseFloat(`${number}e${decimalPlaces}`),
        )}e-${decimalPlaces}`,
      );
    },
    numberToDots(number) {
      return parseFloat(
        number.toString()
          .replace(',', '.')
          .replace(' ', ''),
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/numberMixin.js